export enum CustomerStatus {
  NEW = 'NEW',
  CUSTOMER = 'CUSTOMER',
  CUSTOMER_IN_PROGRESS = 'CUSTOMER_IN_PROGRESS',
  CANCELLED = 'CANCELLED',
}
